(ns manatee.annotation.subs
  (:require #?(:cljs [goog.string :refer [format]])
            [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.annotation.app-db :as annotation-db]
            [manatee.domain.task :as task]
            [manatee.edit.app-db :as edit-db]
            [medley.core :refer [find-first]]
            [re-frame.core :as rf]))

(rf/reg-sub
 ::get-item-flags
 (fn [db _]
   (let [items (annotation-db/get-items db)]
     [(boolean (seq items))
      (some :feedback items)])))

(rf/reg-sub ::get-items (fn [db _] (annotation-db/get-items db)))
(rf/reg-sub ::current-item-id (fn [db _] (annotation-db/current-item db)))

(rf/reg-sub
 ::current-item-raw
 :<- [::get-items]
 :<- [::current-item-id]
 (fn [[items id] _]
   (find-first #(= id (:id %)) items)))

(rf/reg-sub
 ::current-edit
 (fn edits
   [db _]
   (-> (edit-db/get-edits db)
       (get (annotation-db/current-item db)))))

(rf/reg-sub
 ::current-notes
 (fn current-note
   [db _]
   (annotation-db/get-notes db)))

(rf/reg-sub
 ::items-loaded?
 (fn [db _]
   (annotation-db/items-loaded? db)))

(rf/reg-sub
 ::loading?
 (fn [db _]
   (annotation-db/loading? db)))

(rf/reg-sub
 ::items-by-type
 (fn items-by-type
   [db [_ type]]
   (annotation-db/items-by-type db type)))

(rf/reg-sub
 ::unannotated-items-by-type
 (fn unannotated-items-by-type
   [db [_ type]]
   (not-empty
    (annotation-db/items-type-filter
     type
     (annotation-db/unannotated-items db (edit-db/get-edits db))))))

(rf/reg-sub
 ::primary-item
 (fn primary-item
   [db _]
   (->> (annotation-db/get-primary-item db)
        (annotation-db/get-item db))))

(rf/reg-sub
 ::incomplete-feedback?
 (fn incomplete-feedback?
   [db _]
   (->> (annotation-db/get-items db)
        (keep :feedback)
        (some #(not= :done (:status %)))
        (boolean))))

(defn- format-audio-duration
  [audio-length max-length]
  (str "Audio duration: " (format "%.2f" audio-length) " / " (format "%.2f" max-length) "s"))

(rf/reg-sub
 ::current-item
 :<- [::items-loaded?]
 :<- [::get-item-flags]
 :<- [::current-item-raw]
 :<- [::current-edit]
 :<- [::primary-item]
 (fn [[items-loaded? [items? feedback?] current-item current-edit primary-item] _]
   (if items-loaded?
     (let [audio-length-seconds (:audio-length-seconds current-item)
           speaking-time (get-in current-item [:question :speaking-time])]
       (if items?
         (cond-> current-item
           (nil? (:part current-item)) (assoc :part (:part primary-item))
           feedback? (assoc :feedback? true)
           (and audio-length-seconds speaking-time) (assoc :duration-string (format-audio-duration audio-length-seconds speaking-time))
           :always (assoc :edit current-edit))
         {:view-state :no-items}))
     {:view-state :loading})))

(rf/reg-sub
 ::loading-text-visible
 (fn loading-text-visible
   [db _]
   (annotation-db/loading-text-visible db)))

(rf/reg-sub
 ::suppress-part-screen?
 (fn suppress-part-screen?
   [db _]
   (annotation-db/suppress-part-screen? db)))

(rf/reg-sub
 ::part-like?
 (fn part-like?
   [db [_ type]]
   (annotation-db/part-like? db type)))

(rf/reg-sub
 ::current-segment-id
 (fn current-segment-id
   [db [_ item-id]]
   (annotation-db/current-segment-id db item-id)))

(rf/reg-sub
 ::segment-id-to-select
 (fn segment-id-to-select
   [db [_ item-id]]
   (annotation-db/segment-id-to-select db item-id)))

(rf/reg-sub
 ::segment-document
 (fn segment-document
   [db [_ item-id]]
   (annotation-db/segment-document db item-id)))

(rf/reg-sub
 ::segments
 (fn segments
   [db [_ item-id]]
   (annotation-db/segments db item-id)))

(rf/reg-sub
 ::assessment-name
 :<- [::current-item]
 :<- [::task-config-subs/task-configs-map]
 (fn [[current-item task-configs] _]
   (let [task-config-id (:task-config-id current-item)
         task-config (get task-configs (str task-config-id))
         assessment-name (get-in task-config [:data :assessment-name])
         key (keyword assessment-name)
         assessment-entry (find-first #(= key (:value %)) task/assessments)]
     (:representation assessment-entry))))

(rf/reg-sub
 ::intermediate-edit
 (fn intermediate-edit
   [db [_ item-id qa-edit-id]]
   (annotation-db/intermediate-edit db item-id qa-edit-id)))

(rf/reg-sub
 ::validate-now?
 (fn validate-now?
   [db [_ item-id qa-edit-id]]
   (annotation-db/validate-now? db item-id qa-edit-id)))

(rf/reg-sub
 ::reload-segments?
 (fn reload-segments?
   [db [_ item-id]]
   (annotation-db/reload-segments? db item-id)))

(rf/reg-sub
 ::time-markers
 (fn time-markers
   [db [_ item-id]]
   (annotation-db/time-markers db item-id)))

(rf/reg-sub
 ::same-local-and-submitted-document?
 (fn [db _]
   (annotation-db/same-local-and-submitted-document? db)))

(rf/reg-sub
 ::autosaving?
 (fn [db _]
   (annotation-db/autosaving? db)))

(rf/reg-sub
 ::offer-clearing-autosaved-items
 (fn offer-clearing-autosaved-items
   [db _]
   (annotation-db/offer-clearing-autosaved-items db)))

(rf/reg-sub
 ::editor-view
 (fn editor-view
   [db [_ item-id]]
   (annotation-db/editor-view db item-id)))
